import * as React from 'react';
import cn from 'classnames';
import { PlaceAd } from '../../components';
import { PlaceAdButtonContent } from '../../components/PlaceAdButtonContent';
import { TSection } from '../../../../../repositories/frontend-header/entities/entities';

interface IPlaceAdContainerProps {
  section: TSection | undefined;
  addObjectLink: string;
  hasNotBlockedSanction: boolean;
}

export const PlaceAdContainer: React.FC<IPlaceAdContainerProps> = ({
  hasNotBlockedSanction,
  section,
  addObjectLink,
}) => {
  if (!hasNotBlockedSanction) {
    return null;
  }
  const isSerp = section === 'serp';

  const containerClassName = cn({ 'is-serp': isSerp });

  return (
    <PlaceAd containerClassName={containerClassName} link={addObjectLink} buttonContent={<PlaceAdButtonContent />} />
  );
};

PlaceAdContainer.displayName = 'PlaceAdContainer';
